const o = {
  CommonPrefix: "sio_",
  SessionStorePrefix: "sio_session_"
};
export {
  o as StorageKey
};
